export default __webpack_public_path__ + "static/media/dropbox.71307339.svg";